const getPasswordStrongStrength = function (username, password) {
  let rank = 0;
  let blackWord = /admin|123/i;
  let nameInPasswd = new RegExp(`.*${ username }.*`);

  // //
  // // if (2 === type) {
  // //     return rank;
  // // }
  // // 如果仅有数字和一种类型的字母，等级为1
  // if (rank === 2) {
  //   if (
  //     (password.match(/[0-9]/g) && password.match(/[a-z]/g)) ||
  //     (password.match(/[0-9]/g) && password.match(/[A-Z]/g))
  //   ) {
  //     rank = 1;
  //   }
  // }

  // 密码中包含用户名;包含 admin、123 字符;连续四位及以上数字 连续相同字符不能超过四个;常见的弱口令密码
  if (blackWord.test(password) || (username && nameInPasswd.test(password))) {
    return 2;
  } else if (isStepBy4(password)) {
    return 3;
  } else if (isSameBy4(password)) {
    return 4;
  } else if (checkBadPasswd(password)) {
    return 5;
  }
  // // 如果密码小于8位 或 仅有一种类型字符 或 密码与用户名相同，等级为0
  if (password.length < 8) {
    return 1;
  }
  function isSameBy4(str) {
    //连续四位数字相同
    var patrn = /(.)*(.)\2{3}(.)*/g;
    if (patrn.test(str)) {
      return true;
    }
    return false;
  }

  function isStepBy4(str) {
    //连续四位数字递增或递减
    if (str.length < 4) {
      return false;
    }

    var matchNumber = /\d{4,30}/gi;
    var mt = str.match(matchNumber);
    if (mt) {
      for (var j = 0; j < mt.length; j++) {
        var a = mt[j];
        var n = 0;
        var m = 0;
        for (var i = 0; i < a.length - 1; i++) {
          if (a.charCodeAt(i) - a.charCodeAt(i + 1) === -1) {
            n++;
          } else {
            n = 0;
          }
          if (a.charCodeAt(i) - a.charCodeAt(i + 1) === 1) {
            m++;
          } else {
            m = 0;
          }
        }
        if (n >= 3 || m >= 3) {
          return true;
        }
        return false;
      }
    }
  }

  function checkBadPasswd(str) {
    var badPasswd = ['1qaz2wsx', '1qaz@WSX', '!@#$QWER', 'p@ssword', 'passw0rd', 'p@ssw0rd'];
    var a = badPasswd.indexOf(str);
    if (a > -1) {
      return true;
    }
    return false;
  }

  password.match(/[a-z]/g) && rank++; // 有小写字母，等级上升
  password.match(/[A-Z]/g) && rank++; // 有大写字母，等级上升
  password.match(/[0-9]/g) && rank++; // 有数字，等级上升
  password.match(/[^a-zA-Z0-9]/g) && rank++; // 有符号，等级上升

  rank = rank >= 3 ? 0 : 1; // 最高到3

  return rank;
};

export default getPasswordStrongStrength;
